import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitCamelCase'
})
export class SplitCamelCasePipe implements PipeTransform {

  transform(value: string): string {
    if (value != null) {
      return value.replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, " $1")
    }
    /* if (value != null) {
      const result = value.split(/(?=[A-Z])/);
      let word = '';
      result.forEach((val) => {
        word = val + ' '
      })
      return word;
    } */
  }

}
